import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Custom language detector
const customLanguageDetector = {
    type: 'languageDetector',
    async: false,
    detect: () => {
        const lang = navigator.language || navigator.userLanguage;
        return lang.split('-')[0]; // Return only the base language (e.g., 'nl' from 'nl-NL')
    },
    init: () => {},
    cacheUserLanguage: () => {},
};

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(customLanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        // NOTE: The visible admin UI is translated by i18nProvider.js (bundled
        // ra-i18n-polyglot messages), not by this instance. This react-i18next
        // instance only exposes i18n.language to a couple of components, so it does
        // not need a resource backend.
        //
        // Previously this used i18next-http-backend with
        // loadPath '/locales/{{lng}}/translation.json'. Those files don't exist, so
        // the dev server returned index.html, which failed JSON parsing on every cold
        // boot and triggered an intermittent "Cannot read properties of undefined
        // (reading 'undefined')" TypeError during init. Removed the backend.
        fallbackLng: 'en',
        supportedLngs: ['de', 'en', 'es', 'fr', 'hi', 'hy', 'nl', 'pt', 'ru'], // List the supported languages
        nonExplicitSupportedLngs: true, // Normalize 'nl-NL' to 'nl'
        debug: process.env.NODE_ENV === 'development', // dev-only diagnostics; silent in acc/prod builds

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });


export default i18n;
